import { Tooltip } from '@mui/material';
import { ReactNode } from 'react';

type HintIcon = 'info' | 'warning' | 'error' | 'success';

const iconClassName = (icon: HintIcon) => {
  switch (icon) {
    case 'info':
      return 'fa-solid fa-info-circle';
    case 'warning':
      return 'fa-solid fa-exclamation-triangle text-warning';
    case 'error':
      return 'fa-solid fa-exclamation-triangle text-danger';
    case 'success':
      return 'fa-solid fa-check-circle text-green';
  }
};

type HintProps = {
  title: ReactNode;
  icon?: HintIcon;
  className?: string;
};

const Hint = ({ title, icon = 'info', className }: HintProps) => {
  return (
    <Tooltip arrow title={title}>
      <span className={className}>
        <i className={iconClassName(icon)} />
      </span>
    </Tooltip>
  );
};

export default Hint;
